/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-case-declarations */
import React, { ChangeEvent, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import VehicleSlider from "./VehicleSlider";
import MainTable from "./MainTable";
import style from "../Styles/mainDashboard.module.css";
import { getData } from "../Services/getData";
import { localUrlEnum, urlEnum } from "../Utils/urlEnum";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TuneIcon from "@mui/icons-material/Tune";
import { isMobile } from "../Utils/utils";
import { Typography } from "@mui/material";
import {
  componentNames,
  tipStatusVehicule,
  vehiclesTabs,
} from "../Utils/Constants";
import { VehiclesTab } from "../Utils/autocompleteEnum";
import { StatusModel } from "../Models/Models";
import {
  buildVehiclesApiUrl,
  buildFilterNavigateUrl,
} from "../Utils/filterUrlBuilder";

export type PillsProps = {
  status: string;
  statusVehicul: string;
  users: string;
  company: string;
  locations: string;
  physical_location_ids?: string;
  vehicleTypes: string;
  purchaseType?: string;
  minPrice: number | null;
  maxPrice: number | null;
  visible: string | number;
  statusError: string;
  page: number;
  perPage: number;
  search: string | null;
  tvaRecovered: string | null;
  showIncompleteVehicles?: boolean;
  sortByCreatedAt?: string | boolean;
  showNegativeProfit?: string | boolean;
  category_id?: string | null;
  physicalVehicleStatus?: string;
  websiteIntegrations?: string;
  brand?: string;
  model?: string;
  gearbox?: string;
  bodyType?: string;
};

export type StateProps = {
  vehicles: Array<any>;
  vehiclesNumber: number;
  physicalStatuses: Array<StatusModel>;
  sellingStatuses: Array<StatusModel>;
  acquisitionsSum: number;
  distinctLocationIds?: Array<number | string>;
  distinctPhysicalLocations?: Array<string>;
};

export type AuthorizationStateProps = {
  authorizations: Array<any>;
  authorizationsNumber: number;
};

export default function MainDashboard(props: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const [users, setUsers] = useState({
    vanzatori: [],
    useriAchizitie: [],
    useriReservari: [],
  });
  const [state, setState] = useState<StateProps>({
    vehicles: [],
    vehiclesNumber: 0,
    physicalStatuses: [],
    sellingStatuses: [],
    acquisitionsSum: 0,
    distinctLocationIds: [],
    distinctPhysicalLocations: [],
  });
  const [pills, setPills] = useState<PillsProps>({
    status: vehiclesTabs[0].code,
    statusVehicul: "[]",
    users: "[]",
    company: "[]",
    locations: "[]",
    vehicleTypes: "[]",
    purchaseType: "[]",
    minPrice: null,
    maxPrice: null,
    visible: "null",
    statusError: "null",
    page: 0,
    perPage: 10,
    tvaRecovered: "null",
    search: null,
    showIncompleteVehicles: false,
    showNegativeProfit: false,
    sortByCreatedAt: false,
    category_id: null,
    physicalVehicleStatus: "[]",
    websiteIntegrations: "[]",
    brand: "[]",
    model: "[]",
    gearbox: "[]",
    bodyType: "[]",
    physical_location_ids: "[]",
  });

  const [openAccordion, setOpenAccordion] = useState(false);
  const [value, setValue] = useState(0);
  const [vehiclesCategories, setVehiclesCategories] = useState<any>(null);

  /**
   *
   */
  useEffect(() => {
    getData(urlEnum.userFilters).then((res: any) => {
      setUsers(res.data);
    });
  }, []);

  /**
   *
   */
  useEffect(() => {
    if (vehiclesCategories?.length) getUrlVehicles(vehiclesCategories);
    else
      getData(
        `${urlEnum.status_id}/getByType/${tipStatusVehicule.vehicleCategory}`
      ).then((res: any) => {
        setVehiclesCategories(res.data?.data);
        getUrlVehicles(res.data?.data);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const getUrlVehicles = (vehiclesCategories: any) => {
    const search = location.search.split("?");
    const newFilters = Object.assign({}, pills) as any;
    search.forEach((value) => {
      if (value !== "") {
        const values = value.split("=");
        if (values[0] === "search")
          newFilters[values[0]] = decodeURIComponent(values[1]);
        if (values[0] === "visible") newFilters[values[0]] = values[1];
        if (values[0] === "page") newFilters[values[0]] = +values[1] - 1;
        else
          newFilters[values[0]] = !isNaN(+values[1]) ? +values[1] : values[1];
        if (values[1] === "null") newFilters[values[0]] = null;
      }
    });

    if (vehiclesCategories?.length && newFilters.category_id) {
      const category = vehiclesCategories.findIndex(
        (category: any) => category.id === newFilters.category_id
      );
      if (category !== -1) {
        setValue(category);
      } else {
        setValue(0);
      }
    } else {
      setValue(0);
    }
    if (newFilters.showIncompleteVehicles)
      newFilters.showIncompleteVehicles =
        newFilters.showIncompleteVehicles == "true" ||
        newFilters.showIncompleteVehicles == true; //pentru ca valoarea venea ca string si nu functiona switch-ul cu string
    getVehicles(newFilters);

    setPills(newFilters);
  };

  /**
   *
   * @param newFilters
   */
  async function getVehicles(newFilters: any) {
    const url = buildVehiclesApiUrl(urlEnum.vehicles, newFilters);
    const res = await getData(url);
    setState(res.data);
  }

  /**
   *
   * @param event
   * @param newValue
   */
  const handleSliderChange = (_: any, newValue: any) => {
    const updatedPills = {
      ...pills,
      minPrice: newValue[0],
      maxPrice: newValue[1],
    };
    navigate(`${localUrlEnum.vehicles}${buildFilterNavigateUrl(updatedPills)}`);
  };

  /**
   *
   * @param event
   */
  const handleMinInputChangeURL = (event: any) => {
    // Remove spaces from the value before storing in URL
    const cleanedValue = event.target.value?.replace(/\s/g, "");
    const updatedPills = {
      ...pills,
      minPrice: cleanedValue === "" ? null : cleanedValue,
    };
    navigate(`${localUrlEnum.vehicles}${buildFilterNavigateUrl(updatedPills)}`);
  };

  /**
   *
   * @param event
   */
  const handleMaxInputChangeURL = (event: any) => {
    // Remove spaces from the value before storing in URL
    const cleanedValue = event.target.value?.replace(/\s/g, "");
    const updatedPills = {
      ...pills,
      maxPrice: cleanedValue === "" ? null : cleanedValue,
    };
    navigate(`${localUrlEnum.vehicles}${buildFilterNavigateUrl(updatedPills)}`);
  };

  /**
   * Generic handler for filter changes
   */
  const onChangeTextField = (_: any, newValue: any, name: string) => {
    const updatedPills = {
      ...pills,
      [name]: newValue ? JSON.stringify(newValue) : null,
    };
    navigate(
      `${localUrlEnum.vehicles}${buildFilterNavigateUrl(updatedPills)}`,
      { state: { openCollapsable: true } }
    );
  };

  /**
   * Update status error filter and navigate
   */
  function changeStatusError(statusError: string) {
    const updatedPills = { ...pills, statusError };
    navigate(`${localUrlEnum.vehicles}${buildFilterNavigateUrl(updatedPills)}`);
  }

  /**
   * Update TVA recovered filter and navigate
   */
  function changeTvaRecovered(tvaRecovered: string) {
    const updatedPills = { ...pills, tvaRecovered };
    navigate(`${localUrlEnum.vehicles}${buildFilterNavigateUrl(updatedPills)}`);
  }

  /**
   *
   * @param event
   * @param index
   */
  const handleChange = (event: any, index: number) => {
    deleteFilters();
    const categoryId = vehiclesCategories[index].id;
    navigate(
      `${localUrlEnum.vehicles}?status=${
        pills.status
      }?category_id=${categoryId}?page=${1}?perPage=${
        pills.perPage
      }?showIncompleteVehicles=${pills.showIncompleteVehicles}`
    );
  };

  /**
   *
   * @param newFilters
   */
  function handleAccordion(open: boolean) {
    setOpenAccordion(open);
  }

  /**
   *
   * @param newFilters
   */
  function setShowIncompleteVehicles(
    event: ChangeEvent<HTMLInputElement>,
    newValue: boolean
  ) {
    onChangeTextField(event, newValue, "showIncompleteVehicles");
    setPills({ ...pills, showIncompleteVehicles: newValue });
  }

  /**
   *
   */
  function deleteFilters() {
    setPills({
      ...pills,
      status: VehiclesTab.unsold,
      statusVehicul: "[]",
      users: "[]",
      company: "[]",
      locations: "[]",
      vehicleTypes: "[]",
      purchaseType: "[]",
      minPrice: null,
      maxPrice: null,
      visible: "null",
      statusError: "null",
      page: 0,
      perPage: 10,
      tvaRecovered: "null",
      search: null,
      sortByCreatedAt: false,
      showIncompleteVehicles: false,
      showNegativeProfit: false,
      category_id: null,
      physicalVehicleStatus: "[]",
      brand: "[]",
      model: "[]",
      gearbox: "[]",
      bodyType: "[]",
    });
  }
  return (
    <div
      style={{ display: "flex", flexDirection: isMobile() ? "column" : "row" }}
    >
      {isMobile() ? (
        <Accordion
          expanded={openAccordion}
          onChange={() => handleAccordion(!openAccordion)}
          style={{ zIndex: 10 }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <TuneIcon style={{ marginRight: 10 }}></TuneIcon>
            <Typography style={{ marginTop: 1 }}>Filtre </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <VehicleSlider
              key={new Date().getTime()}
              data={pills}
              users={users}
              handleSliderChange={handleSliderChange}
              handleMinInputChangeURL={handleMinInputChangeURL}
              handleMaxInputChangeURL={handleMaxInputChangeURL}
              onChangeTextField={onChangeTextField}
              changeStatusError={changeStatusError}
              changeTvaRecovered={changeTvaRecovered}
              handleAccordion={handleAccordion}
              setShowIncompleteVehicles={setShowIncompleteVehicles}
              statusesForFilters={state?.physicalStatuses}
              sellingStatuses={state?.sellingStatuses}
              distinctLocationIds={state?.distinctLocationIds}
              distinctPhysicalLocations={state?.distinctPhysicalLocations}
            />
          </AccordionDetails>
        </Accordion>
      ) : (
        <div className={style.vehicleSlider}>
          <VehicleSlider
            key={new Date().getTime()}
            users={users}
            data={pills}
            handleSliderChange={handleSliderChange}
            handleMinInputChangeURL={handleMinInputChangeURL}
            handleMaxInputChangeURL={handleMaxInputChangeURL}
            onChangeTextField={onChangeTextField}
            changeStatusError={changeStatusError}
            changeTvaRecovered={changeTvaRecovered}
            handleAccordion={handleAccordion}
            setShowIncompleteVehicles={setShowIncompleteVehicles}
            statusesForFilters={state?.physicalStatuses}
            sellingStatuses={state?.sellingStatuses}
            distinctLocationIds={state?.distinctLocationIds}
            distinctPhysicalLocations={state?.distinctPhysicalLocations}
          />
        </div>
      )}

      <div className={style.mainTable}>
        <MainTable
          type={localUrlEnum.vehicles}
          name={componentNames.MainTable}
          key={new Date().getTime()}
          pills={pills}
          state={state}
          value={value}
          handleChange={handleChange}
          getDataRefresh={getUrlVehicles}
          deleteFilters={deleteFilters}
        ></MainTable>
      </div>
    </div>
  );
}
